import styled from '@emotion/styled';
import type { DefaultFieldValues } from '@kizen/api';
import type { EntityRecordDetail } from '@kizen/api/records';
import { isCreatedValue, isNameValue } from '@kizen/checks/field-value';
import { format } from 'date-fns/format';
import { useMemo } from 'react';
import { KizenTypography } from '__app/typography';
import {
  ListCardCell,
  ListCardItem,
  ListCardRow,
} from 'components/Layout/ListCard';
import { TextEllipsisWithTooltip } from '__components/Kizen/Table';

type StandardListItemProps = {
  record: EntityRecordDetail;
  objectId: string;
};

const NO_VALUE = '—';

const StyledListCard = styled(ListCardItem)`
  height: 40px;
  padding-left: 20px;
`;

export const StandardListItem = ({
  objectId,
  record,
}: StandardListItemProps) => {
  const { created, name } = useMemo(() => {
    const result: Pick<Partial<DefaultFieldValues>, 'created' | 'name'> = {};

    for (const fv of Object.values(record.fields)) {
      if (isCreatedValue(fv)) {
        result.created = fv;
      } else if (isNameValue(fv)) {
        result.name = fv;
      }
    }

    return result;
  }, [record]);

  return (
    <StyledListCard>
      <ListCardRow>
        <ListCardCell>
          <TextEllipsisWithTooltip
            type="link"
            to={`${objectId}/${record.id}/details`}
          >
            {name?.value}
          </TextEllipsisWithTooltip>
        </ListCardCell>
        <ListCardCell>
          <KizenTypography>
            {created?.value ? format(created.value, 'MM/dd/yyyy') : NO_VALUE}
          </KizenTypography>
        </ListCardCell>
      </ListCardRow>
    </StyledListCard>
  );
};
